package com.arena_web.generated

import androidx.compose.runtime.Composable
import com.arena_web.ui.sections.cities.CityLandingContent
import com.varabyte.kobweb.core.Page

@Page("/cities/barcelona")
@Composable
fun City_barcelona() = CityLandingContent(GENERATED_CITIES.first { it.slug == "barcelona" })

@Page("/cities/madrid")
@Composable
fun City_madrid() = CityLandingContent(GENERATED_CITIES.first { it.slug == "madrid" })

@Page("/cities/odesa")
@Composable
fun City_odesa() = CityLandingContent(GENERATED_CITIES.first { it.slug == "odesa" })

@Page("/cities/stockholm")
@Composable
fun City_stockholm() = CityLandingContent(GENERATED_CITIES.first { it.slug == "stockholm" })

@Page("/cities/new-york")
@Composable
fun City_new_york() = CityLandingContent(GENERATED_CITIES.first { it.slug == "new-york" })

@Page("/cities/poznan")
@Composable
fun City_poznan() = CityLandingContent(GENERATED_CITIES.first { it.slug == "poznan" })

@Page("/cities/prague")
@Composable
fun City_prague() = CityLandingContent(GENERATED_CITIES.first { it.slug == "prague" })

@Page("/cities/miami")
@Composable
fun City_miami() = CityLandingContent(GENERATED_CITIES.first { it.slug == "miami" })

@Page("/cities/edinburgh")
@Composable
fun City_edinburgh() = CityLandingContent(GENERATED_CITIES.first { it.slug == "edinburgh" })

@Page("/cities/eindhoven")
@Composable
fun City_eindhoven() = CityLandingContent(GENERATED_CITIES.first { it.slug == "eindhoven" })

@Page("/cities/valencia")
@Composable
fun City_valencia() = CityLandingContent(GENERATED_CITIES.first { it.slug == "valencia" })

@Page("/cities/hamburg")
@Composable
fun City_hamburg() = CityLandingContent(GENERATED_CITIES.first { it.slug == "hamburg" })

@Page("/cities/vienna")
@Composable
fun City_vienna() = CityLandingContent(GENERATED_CITIES.first { it.slug == "vienna" })

@Page("/cities/birmingham")
@Composable
fun City_birmingham() = CityLandingContent(GENERATED_CITIES.first { it.slug == "birmingham" })

@Page("/cities/warsaw")
@Composable
fun City_warsaw() = CityLandingContent(GENERATED_CITIES.first { it.slug == "warsaw" })

@Page("/cities/gothenburg")
@Composable
fun City_gothenburg() = CityLandingContent(GENERATED_CITIES.first { it.slug == "gothenburg" })

@Page("/cities/budapest")
@Composable
fun City_budapest() = CityLandingContent(GENERATED_CITIES.first { it.slug == "budapest" })

@Page("/cities/gdansk")
@Composable
fun City_gdansk() = CityLandingContent(GENERATED_CITIES.first { it.slug == "gdansk" })

@Page("/cities/phoenix")
@Composable
fun City_phoenix() = CityLandingContent(GENERATED_CITIES.first { it.slug == "phoenix" })

@Page("/cities/rome")
@Composable
fun City_rome() = CityLandingContent(GENERATED_CITIES.first { it.slug == "rome" })

@Page("/cities/toulouse")
@Composable
fun City_toulouse() = CityLandingContent(GENERATED_CITIES.first { it.slug == "toulouse" })

@Page("/cities/ankara")
@Composable
fun City_ankara() = CityLandingContent(GENERATED_CITIES.first { it.slug == "ankara" })

@Page("/cities/dallas")
@Composable
fun City_dallas() = CityLandingContent(GENERATED_CITIES.first { it.slug == "dallas" })

@Page("/cities/houston")
@Composable
fun City_houston() = CityLandingContent(GENERATED_CITIES.first { it.slug == "houston" })

@Page("/cities/bologna")
@Composable
fun City_bologna() = CityLandingContent(GENERATED_CITIES.first { it.slug == "bologna" })

@Page("/cities/bucharest")
@Composable
fun City_bucharest() = CityLandingContent(GENERATED_CITIES.first { it.slug == "bucharest" })

@Page("/cities/vilnius")
@Composable
fun City_vilnius() = CityLandingContent(GENERATED_CITIES.first { it.slug == "vilnius" })

@Page("/cities/london")
@Composable
fun City_london() = CityLandingContent(GENERATED_CITIES.first { it.slug == "london" })

@Page("/cities/cologne")
@Composable
fun City_cologne() = CityLandingContent(GENERATED_CITIES.first { it.slug == "cologne" })

@Page("/cities/chicago")
@Composable
fun City_chicago() = CityLandingContent(GENERATED_CITIES.first { it.slug == "chicago" })

@Page("/cities/paris")
@Composable
fun City_paris() = CityLandingContent(GENERATED_CITIES.first { it.slug == "paris" })

@Page("/cities/boston")
@Composable
fun City_boston() = CityLandingContent(GENERATED_CITIES.first { it.slug == "boston" })

@Page("/cities/the-hague")
@Composable
fun City_the_hague() = CityLandingContent(GENERATED_CITIES.first { it.slug == "the-hague" })

@Page("/cities/glasgow")
@Composable
fun City_glasgow() = CityLandingContent(GENERATED_CITIES.first { it.slug == "glasgow" })

@Page("/cities/lodz")
@Composable
fun City_lodz() = CityLandingContent(GENERATED_CITIES.first { it.slug == "lodz" })

@Page("/cities/lisbon")
@Composable
fun City_lisbon() = CityLandingContent(GENERATED_CITIES.first { it.slug == "lisbon" })

@Page("/cities/antalya")
@Composable
fun City_antalya() = CityLandingContent(GENERATED_CITIES.first { it.slug == "antalya" })

@Page("/cities/amsterdam")
@Composable
fun City_amsterdam() = CityLandingContent(GENERATED_CITIES.first { it.slug == "amsterdam" })

@Page("/cities/lille")
@Composable
fun City_lille() = CityLandingContent(GENERATED_CITIES.first { it.slug == "lille" })

@Page("/cities/nice")
@Composable
fun City_nice() = CityLandingContent(GENERATED_CITIES.first { it.slug == "nice" })

@Page("/cities/athens")
@Composable
fun City_athens() = CityLandingContent(GENERATED_CITIES.first { it.slug == "athens" })

@Page("/cities/munich")
@Composable
fun City_munich() = CityLandingContent(GENERATED_CITIES.first { it.slug == "munich" })

@Page("/cities/tallinn")
@Composable
fun City_tallinn() = CityLandingContent(GENERATED_CITIES.first { it.slug == "tallinn" })

@Page("/cities/istanbul")
@Composable
fun City_istanbul() = CityLandingContent(GENERATED_CITIES.first { it.slug == "istanbul" })

@Page("/cities/lyon")
@Composable
fun City_lyon() = CityLandingContent(GENERATED_CITIES.first { it.slug == "lyon" })

@Page("/cities/dublin")
@Composable
fun City_dublin() = CityLandingContent(GENERATED_CITIES.first { it.slug == "dublin" })

@Page("/cities/bratislava")
@Composable
fun City_bratislava() = CityLandingContent(GENERATED_CITIES.first { it.slug == "bratislava" })

@Page("/cities/sofia")
@Composable
fun City_sofia() = CityLandingContent(GENERATED_CITIES.first { it.slug == "sofia" })

@Page("/cities/las-palmas")
@Composable
fun City_las_palmas() = CityLandingContent(GENERATED_CITIES.first { it.slug == "las-palmas" })

@Page("/cities/katowice")
@Composable
fun City_katowice() = CityLandingContent(GENERATED_CITIES.first { it.slug == "katowice" })

@Page("/cities/helsinki")
@Composable
fun City_helsinki() = CityLandingContent(GENERATED_CITIES.first { it.slug == "helsinki" })

@Page("/cities/leipzig")
@Composable
fun City_leipzig() = CityLandingContent(GENERATED_CITIES.first { it.slug == "leipzig" })

@Page("/cities/bilbao")
@Composable
fun City_bilbao() = CityLandingContent(GENERATED_CITIES.first { it.slug == "bilbao" })

@Page("/cities/berlin")
@Composable
fun City_berlin() = CityLandingContent(GENERATED_CITIES.first { it.slug == "berlin" })

@Page("/cities/kyiv")
@Composable
fun City_kyiv() = CityLandingContent(GENERATED_CITIES.first { it.slug == "kyiv" })

@Page("/cities/sevilla")
@Composable
fun City_sevilla() = CityLandingContent(GENERATED_CITIES.first { it.slug == "sevilla" })

@Page("/cities/thessaloniki")
@Composable
fun City_thessaloniki() = CityLandingContent(GENERATED_CITIES.first { it.slug == "thessaloniki" })

@Page("/cities/dusseldorf")
@Composable
fun City_dusseldorf() = CityLandingContent(GENERATED_CITIES.first { it.slug == "dusseldorf" })

@Page("/cities/turin")
@Composable
fun City_turin() = CityLandingContent(GENERATED_CITIES.first { it.slug == "turin" })

@Page("/cities/florence")
@Composable
fun City_florence() = CityLandingContent(GENERATED_CITIES.first { it.slug == "florence" })

@Page("/cities/izmir")
@Composable
fun City_izmir() = CityLandingContent(GENERATED_CITIES.first { it.slug == "izmir" })

@Page("/cities/krakow")
@Composable
fun City_krakow() = CityLandingContent(GENERATED_CITIES.first { it.slug == "krakow" })

@Page("/cities/aarhus")
@Composable
fun City_aarhus() = CityLandingContent(GENERATED_CITIES.first { it.slug == "aarhus" })

@Page("/cities/luxembourg")
@Composable
fun City_luxembourg() = CityLandingContent(GENERATED_CITIES.first { it.slug == "luxembourg" })

@Page("/cities/copenhagen")
@Composable
fun City_copenhagen() = CityLandingContent(GENERATED_CITIES.first { it.slug == "copenhagen" })

@Page("/cities/marseille")
@Composable
fun City_marseille() = CityLandingContent(GENERATED_CITIES.first { it.slug == "marseille" })

@Page("/cities/zagreb")
@Composable
fun City_zagreb() = CityLandingContent(GENERATED_CITIES.first { it.slug == "zagreb" })

@Page("/cities/porto")
@Composable
fun City_porto() = CityLandingContent(GENERATED_CITIES.first { it.slug == "porto" })

@Page("/cities/oslo")
@Composable
fun City_oslo() = CityLandingContent(GENERATED_CITIES.first { it.slug == "oslo" })

@Page("/cities/philadelphia")
@Composable
fun City_philadelphia() = CityLandingContent(GENERATED_CITIES.first { it.slug == "philadelphia" })

@Page("/cities/belgrade")
@Composable
fun City_belgrade() = CityLandingContent(GENERATED_CITIES.first { it.slug == "belgrade" })

@Page("/cities/malaga")
@Composable
fun City_malaga() = CityLandingContent(GENERATED_CITIES.first { it.slug == "malaga" })

@Page("/cities/utrecht")
@Composable
fun City_utrecht() = CityLandingContent(GENERATED_CITIES.first { it.slug == "utrecht" })

@Page("/cities/geneva")
@Composable
fun City_geneva() = CityLandingContent(GENERATED_CITIES.first { it.slug == "geneva" })

@Page("/cities/alicante")
@Composable
fun City_alicante() = CityLandingContent(GENERATED_CITIES.first { it.slug == "alicante" })

@Page("/cities/nicosia")
@Composable
fun City_nicosia() = CityLandingContent(GENERATED_CITIES.first { it.slug == "nicosia" })

@Page("/cities/chisinau")
@Composable
fun City_chisinau() = CityLandingContent(GENERATED_CITIES.first { it.slug == "chisinau" })

@Page("/cities/linz")
@Composable
fun City_linz() = CityLandingContent(GENERATED_CITIES.first { it.slug == "linz" })

@Page("/cities/leeds")
@Composable
fun City_leeds() = CityLandingContent(GENERATED_CITIES.first { it.slug == "leeds" })

@Page("/cities/liverpool")
@Composable
fun City_liverpool() = CityLandingContent(GENERATED_CITIES.first { it.slug == "liverpool" })

@Page("/cities/brussels")
@Composable
fun City_brussels() = CityLandingContent(GENERATED_CITIES.first { it.slug == "brussels" })

@Page("/cities/ljubljana")
@Composable
fun City_ljubljana() = CityLandingContent(GENERATED_CITIES.first { it.slug == "ljubljana" })

@Page("/cities/ostrava")
@Composable
fun City_ostrava() = CityLandingContent(GENERATED_CITIES.first { it.slug == "ostrava" })

@Page("/cities/zurich")
@Composable
fun City_zurich() = CityLandingContent(GENERATED_CITIES.first { it.slug == "zurich" })

@Page("/cities/brno")
@Composable
fun City_brno() = CityLandingContent(GENERATED_CITIES.first { it.slug == "brno" })

@Page("/cities/stuttgart")
@Composable
fun City_stuttgart() = CityLandingContent(GENERATED_CITIES.first { it.slug == "stuttgart" })

@Page("/cities/riga")
@Composable
fun City_riga() = CityLandingContent(GENERATED_CITIES.first { it.slug == "riga" })

@Page("/cities/wroclaw")
@Composable
fun City_wroclaw() = CityLandingContent(GENERATED_CITIES.first { it.slug == "wroclaw" })

@Page("/cities/san-sebastian")
@Composable
fun City_san_sebastian() = CityLandingContent(GENERATED_CITIES.first { it.slug == "san-sebastian" })

@Page("/cities/bordeaux")
@Composable
fun City_bordeaux() = CityLandingContent(GENERATED_CITIES.first { it.slug == "bordeaux" })

@Page("/cities/dnipro")
@Composable
fun City_dnipro() = CityLandingContent(GENERATED_CITIES.first { it.slug == "dnipro" })

@Page("/cities/rotterdam")
@Composable
fun City_rotterdam() = CityLandingContent(GENERATED_CITIES.first { it.slug == "rotterdam" })

@Page("/cities/malta")
@Composable
fun City_malta() = CityLandingContent(GENERATED_CITIES.first { it.slug == "malta" })

@Page("/cities/palma")
@Composable
fun City_palma() = CityLandingContent(GENERATED_CITIES.first { it.slug == "palma" })

@Page("/cities/skopje")
@Composable
fun City_skopje() = CityLandingContent(GENERATED_CITIES.first { it.slug == "skopje" })

@Page("/cities/limassol")
@Composable
fun City_limassol() = CityLandingContent(GENERATED_CITIES.first { it.slug == "limassol" })

@Page("/cities/manchester")
@Composable
fun City_manchester() = CityLandingContent(GENERATED_CITIES.first { it.slug == "manchester" })

@Page("/cities/milan")
@Composable
fun City_milan() = CityLandingContent(GENERATED_CITIES.first { it.slug == "milan" })

@Page("/cities/graz")
@Composable
fun City_graz() = CityLandingContent(GENERATED_CITIES.first { it.slug == "graz" })

@Page("/cities/frankfurt")
@Composable
fun City_frankfurt() = CityLandingContent(GENERATED_CITIES.first { it.slug == "frankfurt" })

@Page("/cities/naples")
@Composable
fun City_naples() = CityLandingContent(GENERATED_CITIES.first { it.slug == "naples" })

@Page("/cities/kharkiv")
@Composable
fun City_kharkiv() = CityLandingContent(GENERATED_CITIES.first { it.slug == "kharkiv" })

@Page("/cities/tbilisi")
@Composable
fun City_tbilisi() = CityLandingContent(GENERATED_CITIES.first { it.slug == "tbilisi" })

@Page("/cities/murcia")
@Composable
fun City_murcia() = CityLandingContent(GENERATED_CITIES.first { it.slug == "murcia" })

@Page("/cities/sarajevo")
@Composable
fun City_sarajevo() = CityLandingContent(GENERATED_CITIES.first { it.slug == "sarajevo" })

@Page("/cities/san-francisco")
@Composable
fun City_san_francisco() = CityLandingContent(GENERATED_CITIES.first { it.slug == "san-francisco" })

@Page("/cities/granada")
@Composable
fun City_granada() = CityLandingContent(GENERATED_CITIES.first { it.slug == "granada" })

@Page("/cities/vigo")
@Composable
fun City_vigo() = CityLandingContent(GENERATED_CITIES.first { it.slug == "vigo" })

@Page("/cities/los-angeles")
@Composable
fun City_los_angeles() = CityLandingContent(GENERATED_CITIES.first { it.slug == "los-angeles" })

@Page("/cities/cluj-napoca")
@Composable
fun City_cluj_napoca() = CityLandingContent(GENERATED_CITIES.first { it.slug == "cluj-napoca" })

@Page("/cities/ternopil")
@Composable
fun City_ternopil() = CityLandingContent(GENERATED_CITIES.first { it.slug == "ternopil" })

@Page("/cities/lviv")
@Composable
fun City_lviv() = CityLandingContent(GENERATED_CITIES.first { it.slug == "lviv" })

@Page("/cities/antwerp")
@Composable
fun City_antwerp() = CityLandingContent(GENERATED_CITIES.first { it.slug == "antwerp" })

@Page("/cities/zaragoza")
@Composable
fun City_zaragoza() = CityLandingContent(GENERATED_CITIES.first { it.slug == "zaragoza" })

@Page("/cities/cherkasy")
@Composable
fun City_cherkasy() = CityLandingContent(GENERATED_CITIES.first { it.slug == "cherkasy" })

@Page("/cities/basel")
@Composable
fun City_basel() = CityLandingContent(GENERATED_CITIES.first { it.slug == "basel" })

@Page("/cities/lutsk")
@Composable
fun City_lutsk() = CityLandingContent(GENERATED_CITIES.first { it.slug == "lutsk" })

@Page("/cities/kryvyi-rih")
@Composable
fun City_kryvyi_rih() = CityLandingContent(GENERATED_CITIES.first { it.slug == "kryvyi-rih" })

@Page("/cities/zaporizhzhia")
@Composable
fun City_zaporizhzhia() = CityLandingContent(GENERATED_CITIES.first { it.slug == "zaporizhzhia" })

@Page("/cities/bergen")
@Composable
fun City_bergen() = CityLandingContent(GENERATED_CITIES.first { it.slug == "bergen" })

@Page("/cities/mykolaiv")
@Composable
fun City_mykolaiv() = CityLandingContent(GENERATED_CITIES.first { it.slug == "mykolaiv" })

@Page("/cities/poltava")
@Composable
fun City_poltava() = CityLandingContent(GENERATED_CITIES.first { it.slug == "poltava" })

@Page("/cities/malmo")
@Composable
fun City_malmo() = CityLandingContent(GENERATED_CITIES.first { it.slug == "malmo" })

@Page("/cities/ivano-frankivsk")
@Composable
fun City_ivano_frankivsk() = CityLandingContent(GENERATED_CITIES.first { it.slug == "ivano-frankivsk" })

@Page("/cities/valladolid")
@Composable
fun City_valladolid() = CityLandingContent(GENERATED_CITIES.first { it.slug == "valladolid" })

@Page("/cities/vinnytsia")
@Composable
fun City_vinnytsia() = CityLandingContent(GENERATED_CITIES.first { it.slug == "vinnytsia" })

@Page("/cities/chernivtsi")
@Composable
fun City_chernivtsi() = CityLandingContent(GENERATED_CITIES.first { it.slug == "chernivtsi" })

@Page("/cities/zhytomyr")
@Composable
fun City_zhytomyr() = CityLandingContent(GENERATED_CITIES.first { it.slug == "zhytomyr" })

@Page("/cities/rivne")
@Composable
fun City_rivne() = CityLandingContent(GENERATED_CITIES.first { it.slug == "rivne" })

@Page("/cities/tirana")
@Composable
fun City_tirana() = CityLandingContent(GENERATED_CITIES.first { it.slug == "tirana" })

@Page("/cities/reykjavik")
@Composable
fun City_reykjavik() = CityLandingContent(GENERATED_CITIES.first { it.slug == "reykjavik" })

@Page("/cities/kropyvnytskyi")
@Composable
fun City_kropyvnytskyi() = CityLandingContent(GENERATED_CITIES.first { it.slug == "kropyvnytskyi" })

@Page("/cities/podgorica")
@Composable
fun City_podgorica() = CityLandingContent(GENERATED_CITIES.first { it.slug == "podgorica" })

@Page("/cities/uzhhorod")
@Composable
fun City_uzhhorod() = CityLandingContent(GENERATED_CITIES.first { it.slug == "uzhhorod" })

@Page("/cities/khmelnytskyi")
@Composable
fun City_khmelnytskyi() = CityLandingContent(GENERATED_CITIES.first { it.slug == "khmelnytskyi" })

@Page("/cities/pristina")
@Composable
fun City_pristina() = CityLandingContent(GENERATED_CITIES.first { it.slug == "pristina" })

